import { useEffect, useState } from 'react';

import { ClientJson, RateJson } from '../types/models';
import { apiClient } from '../api';

export interface ApiClientResponse {
  client: ClientJson | undefined;
  costs: RateJson[] | undefined;
  // error: any;
  loading: boolean;
  notFound: boolean;
}

export const useClient = (id: number | undefined | string): ApiClientResponse => {
  const [client, setClient] = useState<ClientJson>();
  const [costs, setCosts] = useState<RateJson[]>([]);
  const [loading, setLoading] = useState(false);
  const [notFound, setNotFound] = useState(false);

  async function fetchData(clientId: number): Promise<void> {
    setLoading(true);
    setNotFound(false);

    try {
      // Les deux appels sont independants : en serie on payait deux
      // allers-retours la ou un seul suffit.
      const [clientResponse, ratesResponse] = await Promise.all([
        apiClient.clients.getClientById(clientId),
        apiClient.rates.getClientRates(clientId),
      ]);
      setClient(clientResponse);
      setCosts(ratesResponse);

      setLoading(false);
    } catch (error) {
      console.error('Error fetching client data:', error);
      setClient(undefined);
      setCosts([]);
      setNotFound(true);
      setLoading(false);
    }
  }
  useEffect(() => {
    if (id) {
      fetchData(+id);
    }
  }, [id]);

  return { client, costs, loading, notFound };
};
